import { Menu, Portal } from '@chakra-ui/react';
import React, { FC } from 'react';
import { Icon } from '../Icon';

import { IconName } from '@fortawesome/fontawesome-svg-core';
import { Item, SubMenuProps } from './types';
import { MenuItem, RegularMenuItem } from './menu-item';
import { OptionGroup, useOptionGroupValue } from './option-group';

export const SubMenu: FC<SubMenuProps> = ({ menuItem, items, isMenuItemOptions }) => {
  const group = useOptionGroupValue(menuItem.submenuConfig, 'checkbox');
  const iconItem: Item = {
    ...menuItem,
    itemConfig: {
      rightIconName: 'chevron-right',
    },
  };
  return (
    <Menu.Root closeOnSelect={false} positioning={{ placement: 'right-end' }}>
      <Menu.TriggerItem
        aria-label={menuItem.ariaLabel}
        data-action={menuItem.dataAction}
        data-object-id={menuItem.dataObjectId}
        data-object-type={menuItem.dataObjectType}
      >
        {menuItem.itemConfig?.iconName && <Icon iconName={menuItem.itemConfig?.iconName as IconName} />}
        <RegularMenuItem item={iconItem} selectionCount={group.selectionCount} />
      </Menu.TriggerItem>
      {/* The parent Menu.Content always sets overflow: hidden and the positioner is position: absolute, so an
          unportaled submenu is clipped past the parent's box in every browser; Portal escapes it. */}
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            {isMenuItemOptions ? (
              <OptionGroup items={items} group={group} />
            ) : (
              items.map((item, index) => (
                <MenuItem
                  key={`${typeof item.text === 'string' ? item.text : 'item'}-${item.value}-${index}`}
                  index={index}
                  item={item}
                  isMenuItemOptions={isMenuItemOptions}
                  value={item.value}
                />
              ))
            )}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
